<footer class="footer">
  <span class="footer-brand">ASTEROIDS QUEST <span class="dim">//</span> SERVER-AUTHORITATIVE ARCADE</span>
  <span class="footer-tech">Rust · 60 Hz simulation · WebSocket</span>
  <span id="conn-status" class="pill dim">offline</span>
</footer>
